import Styled from 'styled-components';

export const FullScreenDiv = Styled.div`
  height: calc(100vh - 75px);
  `;

export default FullScreenDiv;
